export const SECURITY_POLICY = "none";
export const PORTAL_VERSION = "1.23";
export const API_VERSION = "2.34";
